// extracted by mini-css-extract-plugin
export default {"spinner":"spinner-KvEKKRC4","spin":"spin-ATU7DZqY","storybookSpinner":"storybookSpinner-H9P1lkfR"};